import { render, staticRenderFns } from "./LoginBdView.vue?vue&type=template&id=37da76e9&scoped=true&"
import script from "./LoginBdView.vue?vue&type=script&lang=js&"
export * from "./LoginBdView.vue?vue&type=script&lang=js&"
import style0 from "./LoginBdView.vue?vue&type=style&index=0&id=37da76e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37da76e9",
  null
  
)

/* custom blocks */
import block0 from "./LoginBdView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports